<template>
  <div class="bg">
    <div class="container">
      <div class="content">
        <div class="left">
          <home-footer-left></home-footer-left>
        </div>
        <div class="right">
          <home-footer-right></home-footer-right>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HomeFooterLeft from './HomeFooterLeft.vue'
  import HomeFooterRight from './HomeFooterRight.vue'
  export default{
    name: 'homeFooterInfo',
    components: {
      HomeFooterLeft,
      HomeFooterRight
    }
  }
</script>

<style scoped>
  div.bg {
    display: block;
  }
  div.container {
    background-color: rgb(242, 242, 242);
    width: 980px;
    margin: auto;
    display: block;
    padding: 0;
  }
  div.content {
    margin-top: 40px;
    display: block;
  }
  div.left {
    padding: 0;
    margin: 0;
    float: left;
    width: auto;
    display: block;
  }
  div.right {
    padding: 0;
    margin: 0;
    float: left;
    width: auto;
    display: block;
    border-left: solid;
    border-width: 1px;
    border-color: rgb(226, 226, 226);
  }
</style>



// WEBPACK FOOTER //
// HomeFooterInfo.vue?05b0e0d1